export const UNIVERSE_TRACKING_LINK_BASE = `${import.meta.env.VITE_UNIVERSE_HOST}/cds/trackingDetail.do?&parcelNumber=`;
export const ENVIRONMENT_MODE = {
  LIVE: 'LIVE',
  DISASTER_RECOVERY: 'DR',
};
